import { memo } from "react";

/**
 * Pantalla de la raíz "/".
 *
 * "/" no es una página de contenido: el geo-redirect inline del index.html manda
 * al usuario a /sv, /gt o /pa antes de que se descargue el bundle, así que en el
 * camino normal esto no llega a verse.
 *
 * Existe para el caso en que ese redirect no resuelva —ipapi caído, XHR bloqueado
 * por un adblock, timeout— y el usuario quede parado en la raíz. Sin esto vería
 * una pantalla en blanco.
 *
 * Los enlaces van como <a> y no como <Link>: apuntan a la app Next, no a rutas de
 * esta SPA (mismo criterio que el NavBar).
 */
const RootRedirect = memo(() => {
  return (
    <div className="min-h-screen w-full bg-white flex justify-center items-center">
      <div className="w-full max-w-xl px-4 lg:px-0 text-center">
        <h1 className="font-bold text-2xl lg:text-3xl text-[#343A40]">
          Portal inmobiliario en El Salvador, Guatemala y Panamá
        </h1>
        <p className="text-sm lg:text-base text-[#2C2E2B] font-normal mt-4">
          Encuentra casas, apartamentos y proyectos inmobiliarios para comprar o
          alquilar con Propi.
        </p>
        <nav
          aria-label="Elegí tu país"
          className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3"
        >
          <a className="text-green800 underline" href="/sv">
            Propi El Salvador
          </a>
          <a className="text-green800 underline" href="/gt">
            Propi Guatemala
          </a>
          <a className="text-green800 underline" href="/pa">
            Propi Panamá
          </a>
        </nav>
      </div>
    </div>
  );
});

RootRedirect.displayName = "RootRedirect";
export default RootRedirect;
